<template>
  <div class="NewCape">
    <div class="NewCape-background">
      <div class="NewCape-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        新卡类型
      </div>
      <div class="NewCape-type">
        <router-link :to="{path: 'GetCard',query: {necape: '5'}}">
          <div class="NewCape-type-CardName">欧宝卡</div>
        </router-link>
        <!-- <router-link :to="{path: 'GetCard',query: {necape: '4'}}">
          <div class="NewCape-type-CardName">悦卡</div>
        </router-link> -->
        <router-link :to="{path: 'ApplCard'}">
          <div class="NewCape-type-CardName">尊卡</div>
        </router-link>
      </div>
    </div>
    <TextTips></TextTips>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    // 返回上一层
    BackLevel(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  @import "obraocs/NewCape.css";
</style>